const api = [{
  name: 'moduleList',
  method: 'GET',
  path: '/moduleList',
  desc: '获取功能模块列表',
  mock: false,
  params: {}
},
{
  name: 'funInterfaceList',
  method: 'GET',
  path: '/funInterfaceList',
  desc: '获取请求方式列表',
  mock: false,
  params: {}
},
{
  name: 'getSubmitToken',
  method: 'GET',
  path: '/getSubmitToken',
  desc: '获取请求提交token'
}
]

export default {
  BASE_URL: '/common',
  NAMESPACE: 'common',
  api
}



// WEBPACK FOOTER //
// ./src/api/apis/sys/common.js